import { Box, Breadcrumbs, CardHeader, Link } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Grid from '@mui/system/Unstable_Grid';
import { DynamicCard } from '@components';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import moment from 'moment';
const OblerOIDetailsView = ({ $state, UIService, OblOiService }) => {
    const [loading, setLoading] = useState(true);
    const [estados, setEstados] = useState([]);
    const [data, setData] = useState(null);
    const id = $state.params.id;
    const tableInteracoes = useMaterialReactTable({
        enableColumnActions: false,
        enableColumnFilters: false,
        enablePagination: false,
        enableSorting: false,
        enableBottomToolbar: false,
        initialState: {
            density: 'compact'
        },
        muiTableBodyCellProps: ({ row }) => ({
            onDoubleClick: () => {
                window.open($state.href('app.obler.processos.details', { id: row.original.id }, { absolute: true }));
            },
            sx: {
                cursor: 'pointer' //you might want to change the cursor too when adding an onClick
            }
        }),
        renderTopToolbar: ({ table }) => <CardHeader title='Processos'></CardHeader>,
        columns: [
            {
                accessorKey: 'id',
                header: '#',
                size: 50
            },
            {
                accessorKey: 'numeroProcesso',
                header: 'Número de Processo',
                size: 160
            },
            {
                accessorKey: 'parceiro',
                header: 'Número de Parceiro',
                size: 160
            },
            {
                accessorKey: 'Valencia.designacao',
                header: 'Valência'
            },
            {
                accessorKey: 'nomeCliente',
                header: 'Cliente'
            },
            {
                accessorKey: 'nifCliente',
                header: 'NIF',
                size: 80
            },
            {
                accessorKey: 'tlmCliente',
                header: 'Contacto',
                size: 80
            },
            {
                accessorKey: 'morada',
                header: 'Morada'
            },
            {
                accessorFn: row => `${row.cp4} ${('000' + row.cp3).slice(-3)}`,
                header: 'Cód. Postal'
            },
            {
                accessorKey: 'localidade',
                header: 'Localidade'
            }
        ],
        data: data?.Processos || []
    });
    const fetchData = async () => {
        try {
            const aux = await OblOiService.details(id);
            const estadosAux = await OblOiService.states();
            setEstados(estadosAux);
            setData(aux);
        }
        catch (e) {
            console.log(e);
        }
        setLoading(false);
    };
    useEffect(() => {
        if (loading) {
            fetchData();
        }
    }, [loading]);
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Obler
          </Link>
          <Link underline='hover' color='text.primary'>
            Ordens de Intervenção
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            {id}
          </Link>
        </Breadcrumbs>
      </Box>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <DynamicCard title='Detalhes' loading={loading} content={[
            {
                label: 'Número OI',
                value: data?.codigo
            },
            {
                label: 'Parceiro',
                value: data?.Cliente?.nome
            },
            {
                label: 'Número de Identificação Fiscal',
                value: data?.Cliente?.nif
            },
            {
                label: 'Ano',
                value: data?.iidAno
            },
            {
                label: 'Mês',
                value: data
                    ? moment()
                        .set('month', data?.iidOi - 1)
                        .format('MMMM')
                    : ''
            }
            /*
            {
              label: 'Estado',
              value: (
                <HistoryTimeline
                  atual={data?.estadoId}
                  estados={estados.map(r => {
                    return {
                      id: r.id,
                      label: r.designacao
                    };
                  })}
                  historico={data?.Historico.map(r => {
                    return {
                      id: r.id,
                      estado: r.EstadoFinal.designacao,
                      user: r.Funcionario.name,
                      data: r.dataAlteracao,
                      observacoes: r.observacoes
                    };
                  })}
                  onEstadoChange={async (id: number, observacoes?: string) => {
                    try {
                      await OblOiService.changeState($state.params.id, data.estadoId, id, observacoes);
                      UIService.addToast('Alteração de estado efetuada');
                    } catch (e) {
                      UIService.addToast('Ocorreu um erro ao alterar o estado do processo');
                    }
                    fetchData();
                  }}
                />
              )
            }
            */
        ]}/>
        </Grid>
        {false && (<Grid xs={6}>
            <DynamicCard title='Métricas' loading={loading} content={[
                {
                    label: 'Total Processos',
                    value: data?.Processos?.length
                },
                {
                    label: 'Abertos',
                    value: 0
                },
                {
                    label: 'Concluídos',
                    value: 0
                },
                {
                    label: 'Cancelados',
                    value: 0
                },
                {
                    label: 'Taxa Fecho',
                    value: data?.Processos?.length > 0 ? (0 / data?.Processos?.length).toLocaleString('pt-PT', { style: 'percent', maximumFractionDigits: 2 }) : '0%'
                }
            ]}/>
          </Grid>)}
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <MaterialReactTable table={tableInteracoes}/>
        </Grid>
      </Grid>
    </Box>);
};
export default OblerOIDetailsView;
